import React, { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useQuery from "../../Component/devDashboard2/common/useQuery";
import { AuthContext } from "../../context/auth-context";
import {
  fetchCustomerLlms,
  getMarkets,
  getCustomerMonitoringFiletrs,
} from "../../services/apiService";

import EmptyView from "../../Component/EmptyView/EmptyView";
import classes from "./Conversations.module.css";

import DashboardNav from "./Form";
import api from "../../BrandOnBoarding/api";
import { useRef } from "react";
import GenericTable from "../../Component/BuyingJourneyDataTable/GenericTable";
import {
  sanitizeObject,
  transformFunnelData,
} from "../../utils/helpers";
import History from "./History/History";
import useHistory from "./History/useHistory";
import Form from "./DiscoveryForm";
import SnippetModal from "./SnippetModal";
import Share from "./Share/Share";
import { useReactToPrint } from "react-to-print";
import { faDownload } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Box, Button } from "@mui/material";
import { useDailyLimits } from "../../hooks/useDailyLimits";
import Header from "../../Component/Header/Header";
import PdfFilterModal from "./PdfFilterModal";
import MUIIconButton from "../../Component/UI/MUIIconButton/MUIIconButton";

const CONTENT_TYPES = [
  { id: 1, name: "Reach" },
  { id: 1, name: "Sentiment" },
];

const Conversations = (props) => {

  const {
    launchText,
    updateLaunches,
    launchesRemaining,
    isSpecial,
    frequency: launchLimitFrequency,
  } = useDailyLimits("Conversation");

  const [selectedOptionShow, setSelectedOptionShow] = useState("Company/Brand");
  const value = 0;

  const [showData, setShowData] = useState(false);
  const [isDone, setIsDone] = useState(true);
  const [selectedLlmItems, setSelectedLlmItems] = useState([]);
  const [selectedContentMapLlmItems, setSelectedContentMapLlmItems] = useState(
    []
  );
  const [contentMapLlm, setContentMapLlm] = useState();
  const [selectedMarketItems, setSelectedMarketItems] = useState([]);
  const [selectedGeographyItems, setSelectedGeographyItems] = useState([]);
  const [dbLlms, setDbLlms] = useState([]);
  const selectedFrequencyItems = ["Daily"];

  const [brandItems, setBrandItems] = useState([]);
  const [productItems, setProductItems] = useState([]);
  const [selectedBrandItems, setSelectedBrandItems] = useState([]);
  const [selectedProductItems, setSelectedProductItems] = useState([]);
  const [isDiscovery, setIsDiscovery] = useState(false);

  const [personas, setPersonas] = useState([]);
  const [selectedPersona, setSelectedPersona] = useState([]);

  const [customerLlm, setCustomerLlm] = useState([]);
  const [markets, setMarkets] = useState([]);
  const [geography, setGeography] = useState([]);

  const [selectedInputIds, setSelectedInputIds] = useState();

  const [focusAreaInputs, setFocusAreaInputs] = useState(null);

  const [contentMapData, setContentMapData] = useState([]);
  const [monitoringFiletrs, setMonitoringFilters] = useState();
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedCategoryIds, setSelectedCategoryIds] = useState(null);
  const [inputValues, setInputValues] = useState({})
  const [discoveryType, setDiscoveryType] = useState("brand")
  const [activeTab, setActiveTab] = useState("Monitoring");
  const [selectedSiteSuggestions, setSelectedSiteSuggestions] = useState([]);
  const [discoveryInitialValues, setDiscoveryInitialValues] = useState({});
  const [currentHistoryId, setCurrentHistoryId] = useState(null);
  const [currentEntity, setCurrentEntity] = useState("");
  const [excludeBrandOwnedSources, setExcludeBrandOwnedSources] = useState(false);

  // PDF related states
  const [showPdfFilterModal, setShowPdfFilterModal] = useState(false);
  const [pdfFilterOption, setPdfFilterOption] = useState('');

  const pdfRef = useRef();

  const exportToPDF = useReactToPrint({
    contentRef: pdfRef,
    documentTitle: `${selectedBrandItems?.[0] || selectedProductItems?.[0]} Conversations - ${pdfFilterOption.charAt(0).toUpperCase() + pdfFilterOption.slice(1)}`,
    removeAfterPrint: true,
    pageStyle: `
      @page {
        size: A4;
        margin: 10mm;
      }
      
      @media print {
        body {
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
          margin: 0;
          padding: 0;
        }
        
        * {
          box-sizing: border-box;
        }
        
        h1, h2, h3, h4, h5, h6 {
          page-break-after: avoid !important;
          break-after: avoid !important;
          page-break-inside: avoid !important;
          break-inside: avoid !important;
          margin: 4px 0 !important;
          padding: 0 !important;
        }
        
        h1 + div,
        div:has(h1) {
          page-break-after: avoid !important;
          break-after: avoid !important;
        }
        
        table {
          page-break-inside: auto;
          break-inside: auto;
          width: 100%;
          border-collapse: collapse;
          margin: 0 !important;
        }
        
        tr {
          page-break-inside: avoid;
          break-inside: avoid;
        }
        
        thead {
          display: table-header-group;
        }
        
        .MuiCard-root {
          page-break-inside: avoid;
          break-inside: avoid;
          margin: 4px 0 !important;
          padding: 0 !important;
          box-shadow: none !important;
          border: 1px solid #e0e0e0 !important;
        }
        
        .MuiCardContent-root {
          padding: 4px !important;
        }
        
        .MuiTableContainer-root {
          box-shadow: none !important;
          margin: 0 !important;
        }
        
        .MuiTableCell-root {
          padding: 3px 5px !important;
          font-size: 9px !important;
          line-height: 1.2 !important;
        }
        
        .MuiTableCell-head {
          padding: 5px !important;
          font-size: 10px !important;
          font-weight: 600 !important;
        }
        
        .MuiTypography-root {
          margin: 3px 0 !important;
          padding: 0 !important;
        }
        
        p {
          margin: 2px 0 !important;
          orphans: 2;
          widows: 2;
        }
        
        a {
          color: #1976d2;
          text-decoration: none;
          word-break: break-all;
          font-size: 8px !important;
        }
        
        .MuiStack-root {
          margin: 0 !important;
          padding: 0 !important;
          gap: 2px !important;
        }
      }
    `,
  });


  const query = useQuery();
  const { id: historyId } = useParams();

  const frequency = query.get("dateRange");

  const [selectedSubFrequencyItems, setSelectedSubFrequencyItems] = useState(
    frequency || "Current"
  );

  const dispatch = useDispatch();
  const brandProducts = useSelector((state) => state.brandProducts);
  const brands = useSelector((state) => state.brands);

  const { user, authUserEmail } = useContext(AuthContext);

  const { addHistory } = useHistory(authUserEmail);

  const customerId = user?.customer_id || 0;

  // content data apis and states

  const [discussionTopics, setDiscussionTopics] = useState(null);

  const [discussionTopicsLoading, setDiscussionTopicsLoading] = useState(false);
  const [childKey, setChildKey] = useState(0);

  const remountChild = () => {
    setChildKey((prev) => prev + 1);
  };

  const [error, setError] = useState();

  const discussionTopicsAbortCtrRef = useRef(null);



  const fetchAllMetrics = async (payload, additionalHistoryData = {}) => {
    setError(null);
    const controllers = {
      entity_discussion_topics: new AbortController(),
    };

    discussionTopicsAbortCtrRef.current = controllers.entity_discussion_topics;

    let apiConfigs = [
      {
        key: "entity_discussion_topics",
        url: "/metrics/purchase-journey-data",
        updateFn: setDiscussionTopics,
        setLoading: setDiscussionTopicsLoading,
        controller: controllers.entity_discussion_topics,
      },
    ];

    for (const apiConfig of apiConfigs) {
      apiConfig.setLoading(true);

      (async () => {
        try {
          const response = await api.post(apiConfig.url, payload, {
            signal: apiConfig.controller.signal,
          });
          apiConfig.updateFn(response.data);
          const { entity, type, category } = payload;
          const { persona, location, market, siteSuggestions, moduleType } = additionalHistoryData;
          const dataForHistory = {
            entity,
            type,
            category,
            discussionTopics: response?.data,
            persona,
            location,
            market,
            siteSuggestions,
            moduleType,
          };
          const sanitizedData = sanitizeObject(dataForHistory);
          const historyResponse = await addHistory({
            user_email: authUserEmail,
            name: `${entity} ${type} Overview`,
            date: Date.now(),
            category,
            type,
            entity,
            is_purchase_journey: false,
            is_conversations: true,
            json_data: sanitizedData,
          });

          // Set current history ID and entity for sharing
          if (historyResponse?.data?.id) {
            setCurrentHistoryId(historyResponse.data.id);
            setCurrentEntity(entity || "");
          }
        } catch (err) {
          toast.error(err.message)
          setDiscussionTopics(null);
          setDiscussionTopicsLoading(false);
          if (err.name === "AbortError") {
            console.log(`${apiConfig.key} request aborted`);
          } else {
            setError((prev) => ({
              ...(typeof prev === "object" ? prev : {}),
              [apiConfig.key]: err.message,
            }));
            console.error(`${apiConfig.key} error:`, err);
          }
        } finally {
          apiConfig.setLoading(false);
          remountChild();
        }
      })();
    }
  };



  const handleDiscussionTopics = async (values) => {
    const {
      category: dCategory,
      persona: dPersona,
      geography: dGeography,
      brand: dBrand,
      siteSuggestions: dSiteSuggestions,
      market: dMarket,
      excludeBrandOwnedSources: dExcludeBrandOwnedSources,
    } = values || {};

    const category = isDiscovery ? dCategory : selectedCategory?.[0];
    const persona = isDiscovery ? dPersona : selectedPersona?.[0] || "General Profile";
    const location = isDiscovery ? dGeography : selectedGeographyItems?.[0];
    const market = isDiscovery ? dMarket : selectedMarketItems?.[0];
    const entity = isDiscovery
      ? dBrand
      : selectedBrandItems?.[0] || selectedProductItems?.[0];

    const type = isDiscovery
      ? discoveryType
      : selectedOptionShow === "Product"
        ? "product"
        : "brand";

    const excludeFlag = isDiscovery ? dExcludeBrandOwnedSources : excludeBrandOwnedSources;

    const payload = {
      llm: "gpt-4o",
      category,
      type,
      persona: persona || 'General Profile',
      location: location || 'Global',
      entity,
      excludeBrandOwnedSources: excludeFlag,
    };

    // Add site suggestions parameters if any option is selected
    const siteSuggestions = isDiscovery ? dSiteSuggestions : selectedSiteSuggestions;
    if (siteSuggestions && siteSuggestions.length > 0) {
      payload.searchProvider = "grok";
      payload.targetDomains = siteSuggestions;
    }

    if (!category || !entity) {
      toast.warn('Brand or Category is missing !')
      return
    }

    try {
      await fetchAllMetrics(payload, {
        persona,
        location,
        market,
        siteSuggestions,
        moduleType: isDiscovery ? 'discovery' : 'monitoring'
      });
      if (launchesRemaining == 0 && !isSpecial) {
        toast.warn(
          `You have reached your ${launchLimitFrequency} limit`
        );
        return;
      }
      if (!isSpecial) updateLaunches();
    } catch (error) {
      console.error("Error fetching metrics:", error);
    }
  };


  useEffect(() => {
    async function fetchData() {
      const selectedBrandCustomerId =
        query.get("brandCustomerId") || customerId;
      const customerSpecificLlms = await fetchCustomerLlms([
        Number(selectedBrandCustomerId),
      ]);

      setCustomerLlm(customerSpecificLlms?.data);
      const inputFilters = await getCustomerMonitoringFiletrs(customerId);

      // Deep copy to avoid mutation if needed (e.g., structuredClone or JSON approach)
      let filters = {
        ...inputFilters,
        brands: [...(inputFilters?.brands || [])],
        products: [...(inputFilters?.products || [])],
      };

      setMonitoringFilters(filters);

      if (selectedOptionShow === "Company/Brand") {
        const llms = filters?.brands?.[0]?.categories?.[0]?.llms;

        let llmFromQuery = llms?.[0]?.name;

        const markets = filters?.brands?.[0]?.categories?.[0]?.markets;
        let marketFromQuery = markets?.[0]?.name;

        const geography = filters?.brands?.[0]?.categories?.[0]?.geographies;

        let geoFromQuery = geography?.[0]?.name;

        const persona = filters?.brands?.[0]?.categories?.[0]?.personas;
        const category = filters?.brands?.[0]?.categories?.map((item) => {
          return { id: item?.categoryId, name: item?.categoryName };
        });

        const categoryIds = [category?.[0]?.id] || null;

        setDbLlms(llms);
        setMarkets(markets);
        setGeography(geography);

        setSelectedBrandItems([filters?.brands?.[0]?.brand_name]);
        setSelectedPersona([persona?.[0]?.name]);
        setSelectedLlmItems([llmFromQuery]);
        setSelectedMarketItems([marketFromQuery]);
        setSelectedGeographyItems([geoFromQuery]);
        setBrandItems(
          filters?.brands?.map((item) => {
            return { id: item?.customer_brand_id, name: item?.brand_name };
          })
        );
        setPersonas(persona);
        setCategories(category);
        setSelectedCategory([category?.[0]?.name]);
        setSelectedCategoryIds(categoryIds);
      }

      if (selectedOptionShow === "Product") {
        console.log("test==>", filters);
        const geography = filters?.products?.[0]?.categories?.[0]?.geographies;
        const markets = filters?.products?.[0]?.categories?.[0]?.markets;
        const persona = filters?.products?.[0]?.categories?.[0]?.personas;
        const llms = filters?.products?.[0]?.categories?.[0]?.llms;
        const category = filters?.products?.[0]?.categories?.map((item) => {
          return { id: item?.categoryId, name: item?.categoryName };
        });
        const categoryIds = [category?.[0]?.id] || null;

        setDbLlms(llms);
        setGeography(geography);
        setMarkets(markets);
        setSelectedProductItems([filters?.products?.[0]?.product_name]);
        setSelectedPersona([persona?.[0]?.name]);
        setSelectedLlmItems([llms?.[0]?.name]);
        setSelectedMarketItems([markets?.[0]?.name]);
        setSelectedGeographyItems([geography?.[0]?.name]);
        setProductItems(
          filters?.products?.map((item) => {
            return {
              id: item?.customer_brand_product_id,
              name: item?.product_name,
            };
          })
        );
        setPersonas(persona);
        setCategories(category);
        setSelectedCategory([category?.[0]?.name]);
        setSelectedCategoryIds(categoryIds);
      }
    }

    fetchData();
  }, [selectedOptionShow]);

  useEffect(() => {
    async function fetchCustomerLlmsData() {
      if (selectedProductItems && selectedProductItems.length > 0) {
        if (selectedOptionShow === "Product") {
          const geography = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems.includes(item?.product_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.geographies;
          const markets = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems.includes(item?.product_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.markets;
          const persona = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems.includes(item?.product_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.personas;
          const llms = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems.includes(item?.product_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.llms;
          const category = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems?.includes(item?.product_name)
            )?.[0]
            ?.categories?.map((item) => {
              return { id: item?.categoryId, name: item?.categoryName };
            });
          const categoryIds = [category?.[0]?.id] || null;
          setSelectedCategoryIds(categoryIds);
          setDbLlms(llms);
          setGeography(geography);
          setMarkets(markets);
          setPersonas(persona);
          setCategories(category);
          setSelectedLlmItems([llms?.[0]?.name]);
          setSelectedMarketItems([markets?.[0]?.name]);
          setSelectedGeographyItems([geography?.[0]?.name]);
          setSelectedPersona([persona?.[0]?.name]);
          setSelectedCategory([category?.[0]?.name]);
        }
      }
    }

    fetchCustomerLlmsData();
  }, [selectedProductItems]);

  useEffect(() => {
    async function fetchCustomerLlmsData() {
      if (selectedBrandItems && selectedBrandItems.length > 0) {
        if (selectedOptionShow === "Company/Brand") {
          const geography = monitoringFiletrs?.brands?.filter((item) =>
            selectedBrandItems.includes(item?.brand_name)
          )?.[0]?.categories?.[0]?.geographies;
          const markets = monitoringFiletrs?.brands?.filter((item) =>
            selectedBrandItems.includes(item?.brand_name)
          )?.[0]?.categories?.[0]?.markets;
          const persona = monitoringFiletrs?.brands?.filter((item) =>
            selectedBrandItems.includes(item?.brand_name)
          )?.[0]?.categories?.[0]?.personas;
          const llms = monitoringFiletrs?.brands?.filter((item) =>
            selectedBrandItems.includes(item?.brand_name)
          )?.[0]?.categories?.[0]?.llms;
          const category = monitoringFiletrs?.brands
            ?.filter((item) =>
              selectedBrandItems?.includes(item?.brand_name)
            )?.[0]
            ?.categories?.map((item) => {
              return { id: item?.categoryId, name: item?.categoryName };
            });
          const categoryIds = [category?.[0]?.id] || null;
          setSelectedCategoryIds(categoryIds);

          setDbLlms(llms);
          setGeography(geography);
          setMarkets(markets);
          setPersonas(persona);
          setCategories(category);
          setSelectedLlmItems([llms?.[0]?.name]);
          setSelectedMarketItems([markets?.[0]?.name]);
          setSelectedGeographyItems([geography?.[0]?.name]);
          setSelectedPersona([persona?.[0]?.name]);
          setSelectedCategory([category?.[0]?.name]);
        }
      }
    }

    fetchCustomerLlmsData();
  }, [selectedBrandItems]);

  useEffect(() => {
    async function fetchCustomerLlmsData() {
      if (selectedCategory && selectedCategory.length > 0) {
        if (
          selectedProductItems?.length !== 0 &&
          selectedOptionShow === "Product"
        ) {
          const geography = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems.includes(item?.product_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.geographies;
          const markets = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems.includes(item?.product_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.markets;
          const persona = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems.includes(item?.product_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.personas;
          const llms = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems.includes(item?.product_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.llms;

          setDbLlms(llms);
          setGeography(geography);
          setMarkets(markets);
          setPersonas(persona);
        }

        if (
          selectedBrandItems?.length !== 0 &&
          selectedOptionShow === "Company/Brand"
        ) {
          const geography = monitoringFiletrs?.brands
            ?.filter((item) =>
              selectedBrandItems.includes(item?.brand_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.geographies;
          const markets = monitoringFiletrs?.brands
            ?.filter((item) =>
              selectedBrandItems.includes(item?.brand_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.markets;
          const persona = monitoringFiletrs?.brands
            ?.filter((item) =>
              selectedBrandItems.includes(item?.brand_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.personas;
          const llms = monitoringFiletrs?.brands
            ?.filter((item) =>
              selectedBrandItems.includes(item?.brand_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.llms;

          setDbLlms(llms);
          setGeography(geography);
          setMarkets(markets);
          setPersonas(persona);
        }
      }
    }

    fetchCustomerLlmsData();
  }, [selectedCategory]);

  // Load history item from URL parameter
  useEffect(() => {
    async function loadHistoryFromUrl() {
      if (historyId) {
        try {
          const response = await api.get(`/users/content-map-history/${historyId}`);
          if (response?.data?.data) {
            updateStatesFromHistory(response.data?.data);
          }
        } catch (error) {
          console.error("Error loading history:", error);
          toast.error("Failed to load shared conversation.");
        }
      }
    }

    loadHistoryFromUrl();
  }, [historyId]);

  const handleLlmCheckChange = (selected) => {
    const selectedValues = selected?.map((option) => option?.name) || [];

    setSelectedLlmItems(selectedValues.at(-1) ? [selectedValues.at(-1)] : []);
  };

  const handleCategoryCheckChange = (selected) => {
    if (!selected || selected.length === 0) {
      setSelectedCategory([]);
      setSelectedCategoryIds([]);
      return;
    }

    const lastSelected = selected[selected.length - 1];
    setSelectedCategory([lastSelected.name]);
    setSelectedCategoryIds([lastSelected.id]);
  };



  const handlesubFrequencyCheckChange = (key) => {
    setSelectedSubFrequencyItems(key);
  };

  const handleMarketCheckChange = (selected) => {
    let selectedValues = selected?.map((option) => option?.name);
    let lastIndex = selectedValues.length - 1;
    selectedValues = selectedValues?.filter(
      (item, index) => index === lastIndex
    );

    setSelectedMarketItems(selectedValues || []);
  };

  const handleGeographyCheckChange = async (selected) => {
    let selectedValues = selected?.map((option) => option?.name);
    let lastIndex = selectedValues.length - 1;
    selectedValues = selectedValues?.filter(
      (item, index) => index === lastIndex
    );
    const latestValue = selectedValues[selectedValues.length - 1];
    setSelectedGeographyItems(selectedValues || []);

    let geoId = geography.filter((obj) => obj?.name === latestValue)[0]?.id;
    let market = await getMarkets();
    const filtercustomeLlm = customerLlm.filter(
      (obj) => obj?.geography_id === geoId
    );

    if (selectedValues && selectedValues.length === 1) {
      // set customer geography markets

      const marketIds = [
        ...new Set(filtercustomeLlm.map((obj) => obj?.market_id)),
      ];
      market = market?.data.filter((obj) => marketIds.includes(obj?.id));
      setMarkets(market);
    } else if (selectedValues && selectedValues.length > 1) {
      // set customer geography markets

      market = market?.data.filter((obj) => obj?.name === "General Market");
      setMarkets(market);
    }
  };

  const handleProductCheckChange = (selected) => {
    let selectedValues = selected?.map((option) => option?.name);
    let lastIndex = selectedValues.length - 1;
    selectedValues = selectedValues?.filter(
      (item, index) => index === lastIndex
    );

    setSelectedProductItems(selectedValues || []);
  };

  const handleBrandCheckChange = (selected) => {
    let selectedValues = selected?.map((option) => option?.name);
    let lastIndex = selectedValues.length - 1;
    selectedValues = selectedValues?.filter(
      (item, index) => index === lastIndex
    );

    setSelectedBrandItems(selectedValues || []);
  };

  const handlePersonaCheckChange = (selected) => {
    const selectedValues = selected?.map((option) => option?.name);
    let lastIndex = selectedValues.length - 1;
    const lastSelectedValue = selectedValues?.filter(
      (item, index) => index === lastIndex
    );
    setSelectedPersona(lastSelectedValue || []);
  };

  const handleSiteSuggestionsCheckChange = (selected) => {
    const selectedValues = selected?.map((option) => option.value) || [];
    setSelectedSiteSuggestions(selectedValues);
  };




  const handleContentTypeChange = (selected) => {
    let selectedValues = selected?.map((option) => option?.name);
    let lastIndex = selectedValues.length - 1;
    selectedValues = selectedValues?.filter(
      (item, index) => index === lastIndex
    );

    setShowData(false);
  };

  const updateStatesFromHistory = (data) => {
    setContentMapData(data?.json_data?.data);
    setDiscussionTopics(data?.json_data?.discussionTopics);
    setFocusAreaInputs(data?.json_data?.focusAreaInputs);
    setShowData(true);
    setIsDone(true);

    console.log('state==>', data, data?.json_data);

    // Set current history ID and entity for sharing
    setCurrentHistoryId(data?.id);
    setCurrentEntity(data?.entity || "");

    // Restore additional fields from history
    const { persona, location, market, siteSuggestions, moduleType, type, category } = data?.json_data || {};

    // Default to 'discovery' for backward compatibility with old data
    const effectiveModuleType = moduleType || 'discovery';

    // Set module type (discovery or monitoring)
    if (effectiveModuleType === 'discovery') {
      setIsDiscovery(true);
      setActiveTab('Discovery');

      // Set discovery initial values for the form
      setDiscoveryInitialValues({
        brand: data?.entity || "",
        category: category || "",
        persona: persona || "General Profile",
        geography: location || "Global",
        market: market || "",
        siteSuggestions: siteSuggestions || []
      });

      // Set discovery type
      if (type === 'product') {
        setDiscoveryType('product');
      } else {
        setDiscoveryType('brand');
      }
    } else if (effectiveModuleType === 'monitoring') {
      setIsDiscovery(false);
      setActiveTab('Monitoring');

      // Restore entity type (brand or product)
      if (type === 'product') {
        setSelectedOptionShow('Product');
        if (data?.entity) {
          setSelectedProductItems([data.entity]);
        }
      } else if (type === 'brand') {
        setSelectedOptionShow('Company/Brand');
        if (data?.entity) {
          setSelectedBrandItems([data.entity]);
        }
      }

      // Restore other fields for monitoring mode with defaults
      if (persona) {
        setSelectedPersona([persona]);
      } else {
        setSelectedPersona(["General Profile"]);
      }

      if (location) {
        setSelectedGeographyItems([location]);
      } else {
        setSelectedGeographyItems(["Global"]);
      }

      if (market) {
        setSelectedMarketItems([market]);
      }

      if (category) {
        setSelectedCategory([category]);
      }

      if (siteSuggestions && siteSuggestions.length > 0) {
        setSelectedSiteSuggestions(siteSuggestions);
      }
    }
  };

  if (
    selectedOptionShow === "Product" &&
    brandProducts?.data?.data &&
    !brandProducts?.data?.data.length
  ) {
    return <EmptyView message="No Products Found" />;
  }

  const transformDiscussionData = (arr) => {
    if (!arr || arr.length === 0) return;

    return arr.map((obj) => {
      const mainKey = Object.keys(obj).find(
        (k) => k !== "rating" && k !== "explanation" && k !== "sources"
      );

      return {
        // [mainKey]: `${obj?.[mainKey]}-${obj?.rating}`,
        [mainKey]: `${obj?.[mainKey]}`,
        explanation: obj?.explanation,
        sources: obj?.sources || [], // Preserve sources if they exist, otherwise empty array
      };
    });
  };

  // PDF Filter Options
  const pdfFilterOptions = [
    { name: 'Brand Tables Only', value: 'brand' },
    { name: 'Category Tables Only', value: 'category' },
    { name: 'Both Brand and Category', value: 'both' }
  ];

  // Get type label
  const type = selectedOptionShow === "Product" ? "Program" : "Institution";

  // Tables configuration for PDF
  const tablesConfig = [
    // Brand Discussion Topics
    {
      id: "Brand_Discussion_Topics",
      title: `${type} Discussion Topics`,
      data: discussionTopics?.discussionTopics?.entity_discussion_topics,
      sources: discussionTopics?.discussionTopics?.entity_discussion_topics_sources,
      rawData: discussionTopics?.rawData?.discussionTopics?.entity?.results,
      isBrandTable: true,
    },
    // Category Discussion Topics
    {
      id: "Category_Discussion_Topics",
      title: "Category Discussion Topics",
      data: discussionTopics?.discussionTopics?.discussion_topics,
      sources: discussionTopics?.discussionTopics?.discussion_topics_sources,
      rawData: discussionTopics?.rawData?.discussionTopics?.category?.results,
      isBrandTable: false,
    },
    // Brand Key Questions
    {
      id: "Brand_Key_Questions",
      title: `${type} Key Questions`,
      data: discussionTopics?.keyQuestions?.entity_key_questions,
      sources: discussionTopics?.keyQuestions?.entity_key_questions_sources || discussionTopics?.keyQuestions?.entity_key_question_sources,
      rawData: discussionTopics?.rawData?.keyQuestions?.entity?.results,
      isBrandTable: true,
    },
    // Category Key Questions
    {
      id: "Category_Key_Questions",
      title: "Category Key Questions",
      data: discussionTopics?.keyQuestions?.key_questions,
      sources: discussionTopics?.keyQuestions?.key_questions_sources || discussionTopics?.keyQuestions?.key_question_sources,
      rawData: discussionTopics?.rawData?.keyQuestions?.category?.results,
      isBrandTable: false,
    },
    // Brand Purchase Barriers
    {
      id: "Brand_Purchase_Barriers",
      title: `${type} Purchase Barriers`,
      data: discussionTopics?.purchaseBarriers?.entity_data,
      sources: discussionTopics?.purchaseBarriers?.entity_data_sources,
      rawData: discussionTopics?.rawData?.purchaseBarriers?.entity?.results,
      isBrandTable: true,
    },
    // Category Purchase Barriers
    {
      id: "Category_Purchase_Barriers",
      title: "Category Purchase Barriers",
      data: discussionTopics?.purchaseBarriers?.category_data,
      sources: discussionTopics?.purchaseBarriers?.category_data_sources,
      rawData: discussionTopics?.rawData?.purchaseBarriers?.category?.results,
      isBrandTable: false,
    },
    // Brand Purchase Enablers
    {
      id: "Brand_Purchase_Enablers",
      title: `${type} Purchase Enablers`,
      data: discussionTopics?.purchaseEnablers?.entity_data,
      sources: discussionTopics?.purchaseEnablers?.entity_data_sources,
      rawData: discussionTopics?.rawData?.purchaseEnablers?.entity?.results,
      isBrandTable: true,
    },
    // Category Purchase Enablers
    {
      id: "Category_Purchase_Enablers",
      title: "Category Purchase Enablers",
      data: discussionTopics?.purchaseEnablers?.category_data,
      sources: discussionTopics?.purchaseEnablers?.category_data_sources,
      rawData: discussionTopics?.rawData?.purchaseEnablers?.category?.results,
      isBrandTable: false,
    },
    // Brand Customer Needs
    {
      id: "Brand_Customer_Needs",
      title: `${type} Customer Needs`,
      data: discussionTopics?.customerNeeds?.entity_customer_needs,
      sources: discussionTopics?.customerNeeds?.entity_customer_needs_sources,
      rawData: discussionTopics?.rawData?.customerNeeds?.entity?.results,
      isBrandTable: true,
    },
    // Category Customer Needs
    {
      id: "Category_Customer_Needs",
      title: "Category Customer Needs",
      data: discussionTopics?.customerNeeds?.customer_needs,
      sources: discussionTopics?.customerNeeds?.customer_needs_sources,
      rawData: discussionTopics?.rawData?.customerNeeds?.category?.results,
      isBrandTable: false,
    },
    // Brand Customer Pain Points
    {
      id: "Brand_Customer_Pain_Points",
      title: `${type} Customer Pain Points`,
      data: discussionTopics?.customerPainPoints?.entity_customer_pain_points,
      sources: discussionTopics?.customerPainPoints?.entity_customer_pain_points_sources,
      rawData: discussionTopics?.rawData?.customerPainPoints?.entity?.results,
      isBrandTable: true,
    },
    // Category Customer Pain Points
    {
      id: "Category_Customer_Pain_Points",
      title: "Category Customer Pain Points",
      data: discussionTopics?.customerPainPoints?.customer_pain_points,
      sources: discussionTopics?.customerPainPoints?.customer_pain_points_sources,
      rawData: discussionTopics?.rawData?.customerPainPoints?.category?.results,
      isBrandTable: false,
    },
    // Brand Emerging Trends
    {
      id: "Brand_Emerging_Trends",
      title: `${type} Emerging Trends`,
      data: discussionTopics?.customerEmergingTrends?.entity_emerging_trends,
      sources: discussionTopics?.customerEmergingTrends?.entity_emerging_trends_sources,
      rawData: discussionTopics?.rawData?.customerEmergingTrends?.entity?.results,
      isBrandTable: true,
    },
    // Category Emerging Trends
    {
      id: "Category_Emerging_Trends",
      title: "Category Emerging Trends",
      data: discussionTopics?.customerEmergingTrends?.emerging_trends,
      sources: discussionTopics?.customerEmergingTrends?.emerging_trends_sources,
      rawData: discussionTopics?.rawData?.customerEmergingTrends?.category?.results,
      isBrandTable: false,
    },
    // Brand Customer Complaints
    {
      id: "Brand_Customer_Complaints",
      title: `${type} Customer Complaints`,
      data: discussionTopics?.customerComplaints?.entity_customer_complaints,
      sources: discussionTopics?.customerComplaints?.entity_customer_complaints_sources,
      rawData: discussionTopics?.rawData?.customerComplaints?.entity?.results,
      isBrandTable: true,
    },
    // Brand Customer Praises
    {
      id: "Brand_Customer_Praises",
      title: `${type} Customer Praises`,
      data: discussionTopics?.customerPraises?.entity_customer_praises,
      sources: discussionTopics?.customerPraises?.entity_customer_praises_sources,
      rawData: discussionTopics?.rawData?.customerPraises?.entity?.results,
      isBrandTable: true,
    },
    // Brand Buying Journey Prompts
    {
      id: "Brand_Buying_Journey_Prompts",
      title: `${type} Buying Journey Prompts`,
      data: transformFunnelData(
        discussionTopics?.purchaseJourneyQuestions?.entity_questions?.questions_by_funnel_stage
      ),
      isBrandTable: true,
    },
  ];

  // Filter tables based on selection
  const getFilteredTables = () => {
    if (pdfFilterOption === 'brand') {
      return tablesConfig.filter(table => table.isBrandTable);
    } else if (pdfFilterOption === 'category') {
      return tablesConfig.filter(table => !table.isBrandTable);
    } else if (pdfFilterOption === 'both') {
      const brandTables = tablesConfig.filter(table => table.isBrandTable);
      const categoryTables = tablesConfig.filter(table => !table.isBrandTable);
      return [...brandTables, ...categoryTables];
    }
    return [];
  };

  // PDF Handlers
  const handleDownloadClick = () => {
    setShowPdfFilterModal(true);
  };

  const handlePdfFilterChange = (e) => {
    setPdfFilterOption(e.target.value);
  };

  const handlePdfDownload = () => {
    setShowPdfFilterModal(false);
    setTimeout(() => {
      exportToPDF();
    }, 100);
  };

  const handlePdfModalClose = () => {
    setShowPdfFilterModal(false);
    setPdfFilterOption('');
  };

  function dynamicReplace(text) {
    let result = text;

    const replacements = {
      "Brand": "Institution",
      "Buying Journey": "Enrollment Journey",
      "Post-Purchase": "Engagement",
      'Customer': 'Applicant',
      "Purchase": "Enrollment",
    };

    Object.keys(replacements).forEach((key) => {
      const regex = new RegExp(key, "gi"); // case-insensitive
      result = result.replace(regex, replacements[key]);
    });

    return result;
  }

  const TableWrapper = ({
    data,
    title,
    loading,
    error,
    minWidth = "99%",
    sources,
    rawData,
    isFirstPdfTable
  }) => {
    const [open, setOpen] = useState(false);
    return (
      <div className={classes.tablewrapper} style={{ flex: 1, minWidth }}>
        <GenericTable
          sources={sources}
          data={
            title === `${type} Buying Journey Prompts` ||
              title === "Category Buying Journey Prompts"
              ? data
              : transformDiscussionData(data)
          }
          loading={loading}
          title={dynamicReplace(title)}
          error={error}
          open={open}
          setOpen={setOpen}
          rawData={rawData}
          isFirstPdfTable={isFirstPdfTable}
        />
      </div>
    );
  }

  const handleClick = (target) => {
    setActiveTab(target);
  };

  return (
    <div className="bodycontent">


      <div style={{ display: 'flex', justifyContent: 'space-between' }} className="col-md-12">
        <div className="mb-3 w-100 d-flex justify-content-center align-items-center">
          <div style={{ border: "none" }} className="dmqGroup">
            <button
              className={activeTab === "Monitoring" ? "active" : ""}
              onClick={() => {
                handleClick("Monitoring");
                setIsDiscovery(false);
              }}
            >
              Monitoring
            </button>
            &nbsp; &nbsp;
            <button
              className={activeTab === "Discovery" ? "active" : ""}
              onClick={() => {
                handleClick("Discovery");
                setIsDiscovery(true);
              }}
            >
              Discovery
            </button>
          </div>
        </div>
        <Header actionText={launchText} actionVariant="text" />
      </div>
      <div className={classes.section_summary}>
        {isDiscovery ? <div>  <Form handleClickShow={handleDiscussionTopics} discoveryType={discoveryType} setDiscoveryType={setDiscoveryType} setInputValues={setInputValues} initialValues={discoveryInitialValues} /> </div> : <div>
          <DashboardNav
            contentTypes={CONTENT_TYPES}
            handleContentTypeChange={handleContentTypeChange}
            selectedOptionShow={selectedOptionShow}
            brandItems={brandItems}
            categories={categories}
            handleCategoryCheckChange={handleCategoryCheckChange}
            selectedCategory={selectedCategory}
            selectedBrandItems={selectedBrandItems}
            handleBrandCheckChange={handleBrandCheckChange}
            handleProductCheckChange={handleProductCheckChange}
            selectedProductItems={selectedProductItems}
            productItems={productItems}
            selectedPersona={selectedPersona}
            handlePersonaCheckChange={handlePersonaCheckChange}
            personas={personas}
            selectedGeographyItems={selectedGeographyItems}
            handleGeographyCheckChange={handleGeographyCheckChange}
            geography={geography}
            selectedMarketItems={selectedMarketItems}
            handleMarketCheckChange={handleMarketCheckChange}
            markets={markets}
            selectedLlmItems={selectedLlmItems}
            handleLlmCheckChange={handleLlmCheckChange}
            dbLlms={dbLlms}
            selectedSubFrequencyItems={selectedSubFrequencyItems}
            handlesubFrequencyCheckChange={handlesubFrequencyCheckChange}
            showData={showData}
            isDone={!discussionTopicsLoading}
            handleClickShow={handleDiscussionTopics}
            setSelectedOptionShow={setSelectedOptionShow}
            selectedSiteSuggestions={selectedSiteSuggestions}
            handleSiteSuggestionsCheckChange={handleSiteSuggestionsCheckChange}
            excludeBrandOwnedSources={excludeBrandOwnedSources}
            handleExcludeBrandOwnedSourcesChange={(e) => setExcludeBrandOwnedSources(e.target.checked)}
          />
        </div>}
        <div className={` ${classes.history}`}>
          <History
            key={childKey}
            filter={selectedOptionShow === "Product" ? "product" : "brand"}
            updateStatesFromHistory={updateStatesFromHistory}
          />
        </div>
      </div>
      <div>
        <>
          <br />
          <div>
            {(discussionTopics !== null || discussionTopicsLoading) && (
              <>
                <hr />
                <div className={classes.exportBtn} style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                  {currentHistoryId && (
                    <Share historyId={currentHistoryId} entityName={currentEntity} />
                  )}
                  <MUIIconButton
                    title="Download as PDF"
                    onClick={handleDownloadClick}
                    disabled={discussionTopicsLoading}
                    className={classes.downloadBtn}
                  >
                    <FontAwesomeIcon icon={faDownload} />
                  </MUIIconButton>
                </div>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "0.5rem",
                    "@media print": {
                      display: "block",
                      flexWrap: "unset",
                      gap: 0,
                    },
                  }}
                >
                  <TableWrapper
                    data={
                      discussionTopics?.discussionTopics
                        ?.entity_discussion_topics
                    }
                    minWidth="49%"
                    title={`${type} Discussion Topics`}
                    loading={discussionTopicsLoading}
                    sources={
                      discussionTopics?.discussionTopics
                        ?.entity_discussion_topics_sources
                    }
                    rawData={discussionTopics?.rawData?.discussionTopics?.entity?.results}
                  />

                  <TableWrapper
                    data={discussionTopics?.discussionTopics?.discussion_topics}
                    title="Category Discussion Topics"
                    loading={discussionTopicsLoading}
                    minWidth="49%"
                    sources={
                      discussionTopics?.discussionTopics
                        ?.discussion_topics_sources
                    }
                    rawData={discussionTopics?.rawData?.discussionTopics?.category?.results}
                  />
                  <TableWrapper
                    data={discussionTopics?.keyQuestions?.entity_key_questions}
                    minWidth="49%"
                    title={`${type} Key Questions`}
                    loading={discussionTopicsLoading}
                    sources={
                      discussionTopics?.keyQuestions
                        ?.entity_key_questions_sources || discussionTopics?.keyQuestions
                        ?.entity_key_question_sources
                    }
                    rawData={discussionTopics?.rawData?.keyQuestions?.entity?.results}
                  />

                  <TableWrapper
                    data={discussionTopics?.keyQuestions?.key_questions}
                    title="Category Key Questions"
                    loading={discussionTopicsLoading}
                    minWidth="49%"
                    sources={
                      discussionTopics?.keyQuestions?.key_questions_sources || discussionTopics?.keyQuestions?.key_question_sources
                    }
                    rawData={discussionTopics?.rawData?.keyQuestions?.category?.results}
                  />

                  <TableWrapper
                    data={discussionTopics?.purchaseBarriers?.entity_data}
                    title={`${type} Purchase Barriers`}
                    loading={discussionTopicsLoading}
                    minWidth="49%"
                    sources={
                      discussionTopics?.purchaseBarriers?.entity_data_sources
                    }
                    rawData={discussionTopics?.rawData?.purchaseBarriers?.entity?.results}
                  />

                  <TableWrapper
                    data={discussionTopics?.purchaseBarriers?.category_data}
                    title="Category Purchase Barriers"
                    loading={discussionTopicsLoading}
                    minWidth="49%"
                    sources={
                      discussionTopics?.purchaseBarriers?.category_data_sources
                    }
                    rawData={discussionTopics?.rawData?.purchaseBarriers?.category?.results}
                  />

                  <TableWrapper
                    data={discussionTopics?.purchaseEnablers?.entity_data}
                    title={`${type} Purchase Enablers`}
                    loading={discussionTopicsLoading}
                    minWidth="49%"
                    sources={
                      discussionTopics?.purchaseEnablers?.entity_data_sources
                    }
                    rawData={discussionTopics?.rawData?.purchaseEnablers?.entity?.results}
                  />

                  <TableWrapper
                    data={discussionTopics?.purchaseEnablers?.category_data}
                    title="Category Purchase Enablers"
                    loading={discussionTopicsLoading}
                    minWidth="49%"
                    sources={
                      discussionTopics?.purchaseEnablers?.category_data_sources
                    }
                    rawData={discussionTopics?.rawData?.purchaseEnablers?.category?.results}
                  />

                  <TableWrapper
                    data={discussionTopics?.customerNeeds?.entity_customer_needs}
                    title={`${type} Customer Needs`}
                    loading={discussionTopicsLoading}
                    minWidth="49%"
                    sources={
                      discussionTopics?.customerNeeds?.entity_customer_needs_sources
                    }
                    rawData={discussionTopics?.rawData?.customerNeeds?.entity?.results}
                  />

                  <TableWrapper
                    data={discussionTopics?.customerNeeds?.customer_needs}
                    title="Category Customer Needs"
                    loading={discussionTopicsLoading}
                    minWidth="49%"
                    sources={
                      discussionTopics?.customerNeeds?.customer_needs_sources
                    }
                    rawData={discussionTopics?.rawData?.customerNeeds?.category?.results}
                  />

                  <TableWrapper
                    data={discussionTopics?.customerPainPoints?.entity_customer_pain_points}
                    title={`${type} Customer Pain Points`}
                    loading={discussionTopicsLoading}
                    minWidth="49%"
                    sources={
                      discussionTopics?.customerPainPoints?.entity_customer_pain_points_sources
                    }
                    rawData={discussionTopics?.rawData?.customerPainPoints?.entity?.results}
                  />

                  <TableWrapper
                    data={discussionTopics?.customerPainPoints?.customer_pain_points}
                    title="Category Customer Pain Points"
                    loading={discussionTopicsLoading}
                    minWidth="49%"
                    sources={
                      discussionTopics?.customerPainPoints?.customer_pain_points_sources
                    }
                    rawData={discussionTopics?.rawData?.customerPainPoints?.category?.results}
                  />

                  <TableWrapper
                    data={discussionTopics?.customerEmergingTrends?.entity_emerging_trends}
                    title={`${type} Emerging Trends`}
                    loading={discussionTopicsLoading}
                    minWidth="49%"
                    sources={
                      discussionTopics?.customerEmergingTrends?.entity_emerging_trends_sources
                    }
                    rawData={discussionTopics?.rawData?.customerEmergingTrends?.entity?.results}
                  />

                  <TableWrapper
                    data={discussionTopics?.customerEmergingTrends?.emerging_trends}
                    title="Category Emerging Trends"
                    loading={discussionTopicsLoading}
                    minWidth="49%"
                    sources={
                      discussionTopics?.customerEmergingTrends?.emerging_trends_sources
                    }
                    rawData={discussionTopics?.rawData?.customerEmergingTrends?.category?.results}
                  />

                  <TableWrapper
                    data={discussionTopics?.customerComplaints?.entity_customer_complaints}
                    title={`${type} Customer Complaints`}
                    loading={discussionTopicsLoading}
                    minWidth="49%"
                    sources={
                      discussionTopics?.customerComplaints?.entity_customer_complaints_sources
                    }
                    rawData={discussionTopics?.rawData?.customerComplaints?.entity?.results}
                  />

                  <TableWrapper
                    data={discussionTopics?.customerPraises?.entity_customer_praises}
                    title={`${type} Customer Praises`}
                    loading={discussionTopicsLoading}
                    minWidth="49%"
                    sources={
                      discussionTopics?.customerPraises?.entity_customer_praises_sources
                    }
                    rawData={discussionTopics?.rawData?.customerPraises?.entity?.results}
                  />


                  <TableWrapper
                    data={transformFunnelData(
                      discussionTopics?.purchaseJourneyQuestions
                        ?.entity_questions?.questions_by_funnel_stage
                    )}
                    title={`${type} Buying Journey Prompts`}
                    loading={discussionTopicsLoading}
                  />
                </Box>

                {/* Hidden PDF Content */}
                <div style={{ display: 'none' }}>
                  <div ref={pdfRef} style={{ width: '100%', maxWidth: '210mm', margin: '0 auto' }}>
                    <div style={{ padding: '8mm' }}>
                      {/* PDF Header */}
                      <div
                        style={{
                          pageBreakAfter: 'avoid',
                          breakAfter: 'avoid',
                          marginBottom: '12px',
                          paddingBottom: '6px'
                        }}
                      >
                        <h1
                          style={{
                            textAlign: 'center',
                            margin: '0 0 6px 0',
                            fontSize: '18px',
                            color: '#1f2937',
                            pageBreakAfter: 'avoid',
                            breakAfter: 'avoid'
                          }}
                        >
                          {pdfFilterOption === 'brand' && `${type} Conversations Report`}
                          {pdfFilterOption === 'category' && 'Category Conversations Report'}
                          {pdfFilterOption === 'both' && `${type} and Category Conversations Report`}
                        </h1>

                        <div
                          style={{
                            margin: '0',
                            textAlign: 'center',
                            color: '#6b7280',
                            fontSize: '10px',
                            lineHeight: '1.3'
                          }}
                        >
                          <p style={{ margin: '2px 0' }}>
                            <strong>Entity:</strong> {selectedBrandItems?.[0] || selectedProductItems?.[0]} |{" "}
                            <strong>Type:</strong> {type} |{" "}
                            <strong>Category:</strong> {selectedCategory?.[0]}
                          </p>

                          <p style={{ margin: '2px 0' }}>
                            <strong>Persona:</strong> {selectedPersona?.[0]} |{" "}
                            <strong>Geography:</strong> {selectedGeographyItems?.[0]} |{" "}
                            <strong>Market:</strong> {selectedMarketItems?.[0]}
                          </p>

                          <p style={{ margin: '2px 0' }}>
                            <strong>Filter:</strong>{" "}
                            {pdfFilterOption.charAt(0).toUpperCase() + pdfFilterOption.slice(1)}
                          </p>
                        </div>
                      </div>

                      {/* PDF Tables */}
                      {getFilteredTables().map((table, index) => (
                        <div
                          key={table.id}
                          style={{
                            marginBottom: "6px",
                            pageBreakInside: index === 0 ? "auto" : "avoid",
                            breakInside: index === 0 ? "auto" : "avoid",
                          }}
                        >
                          <TableWrapper
                            {...table}
                            isFirstPdfTable={index === 0}
                            loading={false}
                            minWidth="100%"
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

              </>
            )}
          </div>
        </>

      </div>

      {/* PDF Filter Modal */}
      <PdfFilterModal
        open={showPdfFilterModal}
        onClose={handlePdfModalClose}
        pdfFilterOption={pdfFilterOption}
        onFilterChange={handlePdfFilterChange}
        onDownload={handlePdfDownload}
        pdfFilterOptions={pdfFilterOptions}
      />

      <ToastContainer />
    </div>
  );
};

export default Conversations;